import React from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { keyframes } from "@emotion/react";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const RotatedIcon = styled(RefreshIcon)({
  animation: `${spin} 2s linear infinite`,
});

const LoadingIndicator = () => {
  return (
    <IconButton aria-label="refresh">
      <RotatedIcon />
    </IconButton>
  );
};

export default LoadingIndicator;
